import React from 'react';
import Routes from './routes';
import AppProvider from './hooks';

/*STYLED COMPONENTS config*/
import { GlobalStyle } from './styles/global';

/*ANTD config*/
import 'antd/dist/antd.css';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';

const App: React.FC = () => {
  return (
    <ConfigProvider locale={ptBR}>
      <AppProvider>
        <GlobalStyle />
        <Routes />
      </AppProvider>
    </ConfigProvider>
  );
};

export default App;
